var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlueWindowClass(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 490,
    height: 407,
    viewBox: "0 0 490 407",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M485 0H5C2.23858 0 0 2.23858 0 5V402C0 404.761 2.23858 407 5 407H485C487.761 407 490 404.761 490 402V5C490 2.23858 487.761 0 485 0Z",
    fill: "#849DC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485 1.75H5C3.20507 1.75 1.75 3.20507 1.75 5V402C1.75 403.795 3.20507 405.25 5 405.25H485C486.795 405.25 488.25 403.795 488.25 402V5C488.25 3.20507 486.795 1.75 485 1.75Z",
    stroke: "#707070",
    strokeOpacity: 0.45,
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471 56H14V390H471V56Z",
    fill: "#E9E9F2"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6_178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471 56H14V390H471V56Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M469.75 57.25H15.25V388.75H469.75V57.25Z",
    stroke: "#575454",
    strokeOpacity: 0.29,
    strokeWidth: 2.5,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427 18L456 45",
    stroke: "#E9E9F2",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.5 47.5L458.5 20.5",
    stroke: "#E9E9F2",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459 20H429V48H459V20Z",
    stroke: "#E9E9F2",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6_178)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6_178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M193.094 102.496C196.655 85.4592 210.058 73.8405 223.03 76.5452L309.464 94.5679C322.436 97.2726 330.065 113.277 326.503 130.314L282.91 338.85C279.348 355.887 265.945 367.506 252.973 364.801L166.539 346.779C153.567 344.074 145.939 328.07 149.5 311.033L193.094 102.496Z",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.048 109.553L316.667 133.453L275.395 330.883L160.776 306.984L202.048 109.553Z",
    fill: "#FCECFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.563 338.32C219.78 342.068 216.621 344.58 213.508 343.931C210.394 343.282 208.506 339.717 209.289 335.969C210.073 332.221 213.232 329.709 216.345 330.358C219.458 331.007 221.347 334.572 220.563 338.32Z",
    fill: "#FCECFA"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 216.948,
    y: 139.446,
    width: 38.3703,
    height: 41.8233,
    rx: 4.5,
    transform: "rotate(12.4702 216.948 139.446)",
    fill: "#FCECFA",
    stroke: "#61395D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.78,
    y: 204.076,
    width: 33.2902,
    height: 32.7395,
    rx: 4.5,
    transform: "rotate(12.4702 250.78 204.076)",
    fill: "#FCECFA",
    stroke: "#7A4074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.76 226.332L273.663 241.482L259.013 237.625L270.76 226.332Z",
    stroke: "#7A4074"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.752,
    y: 131.853,
    width: 47.5916,
    height: 28.8465,
    rx: 4.5,
    transform: "rotate(12.4702 266.752 131.853)",
    fill: "#FCECFA",
    stroke: "#61395D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.883 151.107L273.653 145.923L279.68 142.983L278.012 140.862L270.609 145.25L275.416 152.602L277.883 151.107ZM278.453 154.065L280.398 154.496L288.678 142.453L286.756 142.027L278.453 154.065ZM287.517 153.238L289.078 155.623L296.583 150.994L291.674 143.883L289.314 145.114L293.494 150.31L287.517 153.238Z",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.373 235.524L263.084 216.701L269.394 240.394L247.373 235.524Z",
    fill: "#FCECFA",
    stroke: "#7A4074"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256.159,
    cy: 212.727,
    rx: 2.54002,
    ry: 2.59535,
    transform: "rotate(12.4702 256.159 212.727)",
    fill: "#7A4074"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 218.661,
    y1: 152.908,
    x2: 248.422,
    y2: 159.489,
    stroke: "#7A4074",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 216.98,
    y1: 160.51,
    x2: 246.741,
    y2: 167.092,
    stroke: "#7A4074",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.299,
    y1: 168.112,
    x2: 245.06,
    y2: 174.694,
    stroke: "#7A4074",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.07,
    y: 167.267,
    width: 19.8601,
    height: 169.591,
    transform: "rotate(12.4702 308.07 167.267)",
    fill: "#FCECFA",
    stroke: "#7A4074",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 318.506,
    y1: 170.696,
    x2: 282.079,
    y2: 335.414,
    stroke: "#7A4074",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.163,
    y: 331.436,
    width: 24.9402,
    height: 19.0605,
    transform: "rotate(12.4702 269.163 331.436)",
    fill: "#FCECFA",
    stroke: "#7A4074",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.24,
    y: 349.175,
    width: 24.9402,
    height: 19.0605,
    transform: "rotate(12.4702 265.24 349.175)",
    fill: "#FCECFA",
    stroke: "#7A4074",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 276.326,
    y1: 339.153,
    x2: 268.886,
    y2: 337.508,
    stroke: "#7A4074",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 292.846,
    y1: 346.793,
    x2: 279.205,
    y2: 343.777,
    stroke: "#7A4074",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.611 164.535L325.305 135.321L327.217 168.428L309.611 164.535Z",
    fill: "#FCECFA",
    stroke: "#7A4074",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.694 142.605L325.235 150.92L318.791 149.495L323.694 142.605Z",
    fill: "#7A4074"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6_178",
    x: 8,
    y: 53,
    width: 469,
    height: 346,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.459 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_178",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6_178",
    x: 144.625,
    y: 76.1543,
    width: 188.625,
    height: 306.805,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_178",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6_178",
    x: 144.625,
    y: 76.1543,
    width: 186.753,
    height: 297.038,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6_178"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6_178",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 490,
    height: 407,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueWindowClass);
export default __webpack_public_path__ + "static/media/blue-window-class.ce968df3f3cd1d65d46778c466169a0f.svg";
export { ForwardRef as ReactComponent };